// Why? https://github.com/sgratzl/chartjs-chart-wordcloud/issues/4#issuecomment-827304369

import { Chart, registerables } from 'chart.js';

Chart.register(...registerables);
